import {Json} from '@supermove/utils';

export type EmailPreviewFormToFormType = {
  projectId: number;
  emailTemplate: any | null;
  metadata?: object;
};

export interface EmailPreviewForm {
  projectId: number;
  emailTemplate: any | null;
  metadata?: string;
}

const _new = ({projectId, metadata}: {projectId: number; metadata?: string}): EmailPreviewForm => ({
  projectId,
  metadata,

  // private
  emailTemplate: {
    subject: '',
    body: '',
    bodyKind: '',
  },
});

const toForm = ({
  projectId,
  emailTemplate,
  metadata,
}: EmailPreviewForm): EmailPreviewFormToFormType => ({
  projectId,
  metadata: metadata ? Json.toForm(metadata) : undefined,

  // private
  emailTemplate,
});

const toMutation = ({projectId, emailTemplate, metadata}: EmailPreviewFormToFormType) => ({
  projectId,
  subject: emailTemplate.subject,
  body: emailTemplate.body,
  bodyKind: emailTemplate.bodyKind,
  metadata: metadata ? Json.toMutation(metadata) : undefined,
});

const EmailPreviewForm = {
  new: _new,
  toForm,
  toMutation,
};

export default EmailPreviewForm;
